import { BACKEND_URL_STORE } from '@constants/server.constant'
import axios from 'axios'

export const listConfigs = () => axios.get(`${BACKEND_URL_STORE}/config`)
